import { useEffect, useRef, useState } from "react";

import { TreeItem, SimpleTreeView } from "@mui/x-tree-view";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import customerHrchyService from "@plannel/services/data/customer-hrchy-service";

import IconButton from "@mui/material/IconButton";
import ClearIcon from '@mui/icons-material/Clear';
import { DoneAll } from "@mui/icons-material";
import debug from "@plannel/utils/debug-util";
import TextField from "@mui/material/TextField";

import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box, FormControlLabel, Checkbox, FormControl, Popover, InputAdornment, Button, Divider } from "@mui/material";

import reduxUtil from "@plannel/utils/redux-util";
import codeUtil from "@plannel/pages/utils/code-util";
import {isArray, isEmpty, isEqual, size} from "lodash";

const CUSTOMER_HRCHY = "CUSTOMER_HRCHY"

/**
 * @param {object} props viewName, onChangeFilter, excludeAllFilters, hideFilters
 * @param {function} onChangeFilter setFilterValue ** required value
 * @param {String} viewName viewName ** required value
 * @param {boolean} hide hide
 * @param {boolean} enableSelectParent enableSelectParent // ex) BfForecastReview
 * @param {object[]} selectedCustomer customerSearch 
 * @param {boolean} unuseClearIcon unuseClearIcon
 * @param {object[]} defaultValue defaultValue :: customerHrchy // ex) BfForecastReview
 * @param {Integer} hrchyNumFilter hrchyNum
 * @param {object} styles { width: 200 }
 * @param {boolean} reload reload
 * @param {boolean} enableMultiSelect enableMultiSelect
 * @param {object[]} customValue customValue :: for value setting customize ex) dpWorkbench 
 * @param {String} label for InputField label value customize ex) dpWorkbench, bfReview
 * @param {boolean} selectLeafs in multi select, selects all leaf nodes when a parent node is selected. ex) RP Monthly Trend
 */
const CustomerHrchyTreeFilter = (props) => {
  const { viewName, onChangeFilter, hide, enableSelectParent, selectedCustomer, unuseClearIcon, defaultValue, hrchyNumFilter, styles, treeload, enableMultiSelect, customValue, label, selectLeafs } = props;
  const hideFilter = hide?.find(el => el === "customer") ?? false;
  const parentSelectable = enableSelectParent === true ? enableSelectParent : false;
  const viewClearIcon = unuseClearIcon === true ? !unuseClearIcon : true;
  const treeCustomerList = selectedCustomer || [];
  const selectHrchyNum = hrchyNumFilter || codeUtil.hrchyNum.HRCHY;
  const multySelectable = enableMultiSelect === true ? enableMultiSelect : false;
  const selectChild = selectLeafs === true ? selectLeafs : false;

  const { t } = useTranslation();
  const [tree, setTree] = useState([]);

  // const [hrchyCdRenderText, setHrchyCdRenderText] = useState("");
  const [hrchyCdState, setHrchyCdState] = useState(reduxUtil.getViewState(viewName)?.filter?.customer?.code ? reduxUtil.getViewState(viewName).filter?.customer.code : reduxUtil.getViewState(viewName)?.filter?.customerHrchy?.hrchyCd ?? "");
  const [hrchyCdText, setHrchyCdText] = useState(reduxUtil.getViewState(viewName)?.filter?.customerHrchy?.name ? reduxUtil.getViewState(viewName)?.filter?.customerHrchy?.name : reduxUtil.getViewState(viewName)?.filter?.customerHrchys?.map(customterHrchy => {
    return customterHrchy?.name}).join(',') ?? "");

  const [anchorEl, setAnchorEl] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isSelected, setIsSelected] = useState(false);
  const [hoveredItem, setHoveredItem] = useState("");

  const open = Boolean(anchorEl);
  const reduxDispatch = useDispatch();
  const inputRef = useRef(null);

  const [checkSelected, setCheckSelected] = useState(reduxUtil.getViewState(viewName)?.filter?.customerCheckSelected || []);

  useEffect(() => {
    if (!multySelectable) {
      const reduxViewState = reduxUtil.getViewState(viewName);
      const customerHrchyReduxViewState = reduxUtil.getViewState(CUSTOMER_HRCHY);
      const customerHrchy = customerHrchyReduxViewState?.customerHrchy || [];

      const filterValue = reduxViewState?.filter ? reduxViewState.filter : {};

      const hrchy = !parentSelectable ? customerHrchy.filter(data => data.leafFlg && data.hrchyCd === hrchyCdState) : customerHrchy.filter(data => data.hrchyCd === hrchyCdState);

      const customer = treeCustomerList.filter(data => data.code === hrchyCdState);

      onChangeFilter(({ ...filterValue, customerHrchy: hrchy.length > 0 ? hrchy[0] : null, customer: customer.length > 0 ? customer[0] : null }));

      const reduxState = reduxUtil.createFilterViewState(viewName, ({ ...filterValue, customerHrchy: hrchy.length > 0 ? hrchy[0] : null, customer: customer.length > 0 ? customer[0] : null }));
      reduxDispatch(reduxUtil.updateViewState(reduxState));

      setAnchorEl(null);

      if (hrchy.length > 0) {
        setIsSelected(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hrchyCdState]);

  const checkNullArray = (values) => {
    if (!values) {
      return null;
    }
    if (isArray(values) && (isEmpty(values[0]) || values[0] === null)) {
      return [];
    }
    return isArray(values) ? values : [values];
  };

  const setCustomerHrchysState = (selectList) => {
    const reduxViewState = reduxUtil.getViewState(viewName);

    const filterValue = reduxViewState?.filter ?? {};

    const checkSelectedArray = checkNullArray(selectList) || checkNullArray(checkSelected);
    if (checkSelectedArray) {
      const filterArrays = isArray(filterValue) ? filterValue : [filterValue];
      const filterHrchyCds = filterArrays?.customerHrchys?.map(val => val.hrchyCd);
      const checkedHrchyCds = checkSelectedArray.map(val => val.hrchyCd);

      if (!isEqual(filterHrchyCds, checkedHrchyCds)) {
        // 중복 제거 (hrchyCd 또는 id 기준)
        const dedupedArray = isArray(checkSelectedArray)
          ? checkSelectedArray.filter(v => v).reduce((acc, cur) => {
            const key = cur?.hrchyCd ?? cur?.id;
            if (key === null) return acc;
            if (!acc.some(x => (x.hrchyCd ?? x.id) === key)) {
              acc.push(cur);
            }
            return acc;
          }, [])
          : checkSelectedArray;
        const customerHrchys = enableMultiSelect ? dedupedArray : dedupedArray?.[0] ?? null;

        const updatedFilter = { ...filterValue, customerHrchys, customerCheckSelected: checkSelectedArray };
        onChangeFilter(updatedFilter);
        const reduxState = reduxUtil.createFilterViewState(viewName, updatedFilter);
        reduxDispatch(reduxUtil.updateViewState(reduxState));
      }
      setCheckSelected(checkSelectedArray);

      if (isEmpty(tree)) {
        setHrchyCdText("");
      } else {
        const leafs = checkSelectedArray.filter(custHrchy => {
          return custHrchy.leafFlg;
        });
        const visibleArray = size(leafs) > 0 ? leafs : checkSelectedArray;
        const hrchyCdTextValue = visibleArray
          .map(custHrchy => {
            return custHrchy?.name;
          })
          .join(",");

        setIsSelected(true);
        setHrchyCdText(hrchyCdTextValue);
      }
    }
  };

  useEffect(() => {
    if (!isSelected) {
      // setHrchyCdRenderText(hrchyCdText);
      if (multySelectable) {
        if (hrchyCdText === "" && (hrchyCdText !== reduxUtil.getViewState(viewName)?.filter?.customerHrchys?.map(customterHrchy => {
          return customterHrchy?.name}).join(','))) { // 초기 or ""

          if (treeload) {
            const dValue = defaultValue ? defaultValue : [];
            const reduxViewState = reduxUtil.getViewState(viewName);
            let defaultText = "";
            if (!selectChild) {
              defaultText = dValue ? dValue.map(customerHrchy => customerHrchy?.name).join(',') : "";
            } else {
              const leaf = dValue?.filter(el => el.leafFlg);
              if (leaf !== null && !isEmpty(leaf)) {
                defaultText = leaf.map(customerHrchy => customerHrchy?.name).join(',');
              }
            }

            setHrchyCdText(defaultText);

            const filterValue = reduxViewState?.filter ? reduxViewState.filter : {};
            const updatedFilter = {
              ...filterValue,
              customerHrchys: dValue,
              customerCheckSelected: dValue
            };

            onChangeFilter(updatedFilter);

            const reduxState = reduxUtil.createFilterViewState(viewName, updatedFilter);
            reduxDispatch(reduxUtil.updateViewState(reduxState));
          }
        }
      }

    } else {
      setIsSelected(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [hrchyCdText]);

  useEffect(() => {
    if (multySelectable) {
      const hrchyList = reduxUtil.getViewState(viewName)?.filter?.customerHrchys ? reduxUtil.getViewState(viewName)?.filter?.customerHrchys : defaultValue;
      const defaultText = hrchyList?.map(customterHrchy => {
        return customterHrchy?.name}).join(',');
      setHrchyCdText(defaultText);
    } else {
      if (reduxUtil.getViewState(viewName)?.filter?.customer === null && reduxUtil.getViewState(viewName)?.filter?.customerHrchy === null && defaultValue) {
        setHrchyCdState(defaultValue.hrchyCd);
        setHrchyCdText(defaultValue.name);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  useEffect(() => {
    if (customValue && size(tree) > 0) {
      setCustomerHrchysState(customValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customValue]);

  useEffect(() => {
    if (treeload) {
      if (defaultValue) {
        if (multySelectable) {
          setCheckSelected(defaultValue);
          let defaultText = "";
          if (!selectChild) {
            defaultText = defaultValue.map(customterHrchy => {
              return customterHrchy?.name}).join(',');
          } else {
            const leaf = defaultValue?.filter(el => el.leafFlg);
            if (leaf !== null && !isEmpty(leaf)) {
              defaultText = leaf.map(customterHrchy => {
                return customterHrchy?.name}).join(',');
            }
          }
          setHrchyCdText(defaultText);
        } else {
          setHrchyCdState(defaultValue.hrchyCd);
          setHrchyCdText(defaultValue.name);
        }
      } else {
        setHrchyCdState("");
        setHrchyCdText("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [treeload]);

  const loadCustomerData = () => {
    const custHrchyData = [];
    customerHrchyService.getHrchyFilter({ hrchyNum: selectHrchyNum })
      .then(response => {
        const { results } = response.data;
        custHrchyData.push(...getAllDescendants(results?.[0]));
        setTree(results?.[0]);
      })
      .catch(e => {
        debug(e);
      })
      .then(() => {
        const customerHrchyReduxState = reduxUtil.createObjectState(CUSTOMER_HRCHY, { customerHrchy: custHrchyData });
        reduxDispatch(reduxUtil.updateViewState(customerHrchyReduxState));
      });
  };

  useEffect(() => {
    loadCustomerData();
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [selectHrchyNum]);

  const handleClose = (e, hrchyCd) => {
    if (multySelectable) { // for multySelect
      setCustomerHrchysState();
    } else {
      if (!parentSelectable) {
        if (tree.filter(data => data.leafFlg && data.name === hrchyCd).length === 0 &&
          tree.filter(data => data.leafFlg && data.name === hrchyCdText).length === 0) {
          setHrchyCdState("");
          setHrchyCdText("");
        }
      }
    }

    setAnchorEl(null);
  };

  const handleMouseEnter = () => {
    setIsFocused(true);
  };

  const handleMouseLeave = () => {
    setIsFocused(false);
  };

  const handleTreeItemHover = (event, node) => {
    if (enableSelectParent) {
      setHoveredItem(node);
    } else {
      if (node.leafFlg) {
        setHoveredItem(node);
      }
    }
  };

  const getAllDescendants = node => {
    const allDescendants = [];

    const addChild = child => {
      allDescendants.push(child);
      if (child?.children) {
        child.children.forEach(descend => {
          addChild(descend);
        });
      }
    };

    addChild(node);
    return allDescendants;
  };

  const getOnChange = (checked, node) => {
    // for multiselect checkbox logic
    const allDescendants = getAllDescendants(node);
    let checkedArray = checked ? [...new Set([...checkSelected, ...allDescendants])]
      : checkSelected?.filter(value => !allDescendants.some(obj => obj.hrchyCd === value.hrchyCd));

    if (!selectChild) {
      checkedArray = checkedArray?.filter(data => {
        return data.hrchyLv === node.hrchyLv;
      });
    } else {
      if (!checked) {
        checkedArray = checkedArray?.filter(checkedNode => !allDescendants.includes(checkedNode.hrchyCd) && !node.ancester?.includes(checkedNode.hrchyCd));
      } else {
        const checkedHrchyCds = checkedArray.map(hrchy => hrchy.hrchyCd);
        const allList = getAllDescendants(tree).filter(hrchy => hrchy?.descendant.includes(checkedHrchyCds));
        checkedArray = [...new Set([...checkedArray, ...allList])];
      }
    }
    setCheckSelected(checkedArray); // tree render
  };


  function renderTree(node) {
    // const descendHrchys = getDescends(node);
    const children = node?.children;
    const checkedArrays = isArray(checkSelected) ? checkSelected : [checkSelected];
    const checked = checkedArrays?.some(checkedSelect => checkedSelect.hrchyCd === node.hrchyCd);
    const indeterminate = checkedArrays?.some(checkedSelect => node?.descendant?.includes(checkedSelect.hrchyCd)) && !checked;

    return (
        <TreeItem
          itemId={node.hrchyCd}
          key={node.hrchyCd}
          sx={{ boxSizing: "border-box" }}
          label= {
            !multySelectable ? <Box className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
              sx={{
                padding: '5px 8px',
              }}
              onClick={(e) => {
                if (!parentSelectable) {
                  if (node.leafFlg) {
                    setHrchyCdText(node.name);
                    setHrchyCdState(node.hrchyCd);
                    handleClose(e, node.name);
                  }
                } else {
                  setHrchyCdText(node.name);
                  setHrchyCdState(node.hrchyCd);
                  handleClose(e, node.name);
                }
              }}
              onMouseEnter={(event) => handleTreeItemHover(event, node)}
              onMouseLeave={() => setHoveredItem(null)}
            >{node.name}</Box> :
              <FormControlLabel
                sx={{ width: "95%" }}
                control={
                  <Checkbox
                    sx={{ p: 0.5 }}
                    checked={checked}
                    //disabled={disabled}
                    size="small"
                    indeterminate={indeterminate}
                    onChange={(event) => getOnChange(event.currentTarget.checked, node)}
                    onClick={(e) => e.stopPropagation()}
                  />
                }
                label={<Box className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
                  sx={{
                    padding: '3px 9px',
                    width: "95%"
                  }}
                  onMouseEnter={(event) => handleTreeItemHover(event, node)}
                  onMouseLeave={() => setHoveredItem(null)}
                >{node.name}</Box>}
                key={node.id}
              />
          }
        >
          {children?.map(child => renderTree(child))}
        </TreeItem>
    )
  }

  function createTree(customerHrchys) {
    if (!isEmpty(customerHrchys)) {
      const defaultExpandList = [];
      defaultExpandList.push(customerHrchys?.hrchyCd);

      return (
        <Box>
          {isEmpty(customerHrchys) ? (
            <Box
              id={"cust-hrchy-tree-list"}
              className={"MuiAutocomplete-popper MuiAutocomplete-noOptions"}
              sx={{
                padding: "8px 16px",
                minWidth: 230,
                color: "#888",
              }}>
              {"No Options"}
            </Box>
          ) : (
            <SimpleTreeView
              id={"hrchy-tree-view"}
              defaultExpandedItems={defaultExpandList}
              sx={{
                maxHeight: 360,
                paddingLeft: "5px",
                overflowY: "auto",
                minWidth: 230,
              }}
            >
              {renderTree(customerHrchys)}
            </SimpleTreeView>
          )}
        </Box>
      )
    }
    return null;
  }

  const handleClick = (event) => {
    inputRef.current.focus()
    setAnchorEl(event.currentTarget);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !multySelectable) {
      if (hoveredItem) {
        setHrchyCdText(hoveredItem.name);
        setHrchyCdState(hoveredItem.hrchyCd);
        inputRef.current?.focus();
        setAnchorEl(null);
      }
    }
  };

  return !hideFilter ? (
    <>
      <FormControl
        className={"customer-hrchy-tree-filter"}
        size="small"
        sx={{ mr: 1, minWidth: 230, width: 240, ...styles }}
      >
        <TextField
          size="small"
          label={label ? t(label) : t("customerHrchy")}
          type="string"
          onKeyDown={(e) => handleKeyPress(e)}
          onClick={(e) => handleClick(e)}
          onMouseEnter={() => handleMouseEnter()}
          onMouseLeave={() => handleMouseLeave()}
          value={hrchyCdText ?? ""}
          onChange={(event) => setHrchyCdText(event.target.value)}
          inputRef={inputRef}
          autoComplete="off"
          InputProps={{
            endAdornment: hrchyCdText?.length > 0 ? (
              <>
                {viewClearIcon && isFocused ? <IconButton size="small" aria-label="clear text" onClick={(e) => {
                  e.stopPropagation(); // 부모 onClick 호출 방지
                  setHrchyCdText("");
                  setHrchyCdState("");
                  setCheckSelected([]);
                  setCustomerHrchysState([]);
                }}>
                  <ClearIcon sx={{ fontSize: '1.2rem' }} />
                </IconButton> : null}
                <InputAdornment position="end">
                  <IconButton aria-label="search" sx={{ padding: 0 }} size="small">{open ? <ArrowDropUpIcon />
                    : <ArrowDropDownIcon />}</IconButton>
                </InputAdornment>
              </>
            ) : <InputAdornment position="end">
              <IconButton aria-label="search" size="small" >{open ? <ArrowDropUpIcon />
                : <ArrowDropDownIcon />}</IconButton>
            </InputAdornment>
          }}
        />
      </FormControl>
      <Popover open={Boolean(open)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        disableAutoFocus
        disableEnforceFocus
        TransitionProps={{ timeout: 0 }}
      >
        <Box>
          <Box sx={{ minWidth: 180, width: 240, overflowY: "auto", overflowX: "hidden", ...styles }}>
            {
              createTree(tree)
            }
          </Box>
          {
            multySelectable ? <Box>
              <Divider sx={{ backgroundColor: "primary.main", borderColor: "primary.main", borderWidth: 0.5, opacity: 0.2 }} />
              <Box 
                sx={{
                  padding: '8px',
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}>
                <Button 
                  sx= {{ mr: 1.1 }}
                  variant="contained"
                  startIcon={<DoneAll />}
                  size="small"
                  color="primary"
                  onClick={handleClose} >
                  {t("confirm")}
                </Button>
              </Box>
            </Box> : null
          }
        </Box>
      </Popover>
    </>
  ) : null;
}

export default CustomerHrchyTreeFilter;